const attachBehavior = (module, el) => {
  module.default(
    $(el),
  );
};

const attachBehaviors = (event) => {
  let elements;

  if(event.type == 'ModalOpened') {
    elements = document.querySelectorAll('.modal [data-behavior]');
  } else if(event.type == 'PaginationLoaded') {
    elements = document.querySelectorAll('.pagination-wrapper [data-behavior]');
  } else {
    elements = document.querySelectorAll('[data-behavior]');
  }

  Array.from(elements).forEach((el) => {
    const behaviors = el.dataset.behavior.split(' ');

    behaviors.forEach((behavior) => {
      if(process.env.NODE_ENV === 'production') {
        import(
          `javascripts/behaviors/${behavior}`
        ).then((module) => {
          attachBehavior(module, el);
        });
      } else {
        import(
          /* webpackMode: "eager" */
          `javascripts/behaviors/${behavior}`
        ).then((module) => {
          attachBehavior(module, el);
        });
      }
    });
  });
};

document.addEventListener(
  'DOMContentLoaded',
  attachBehaviors,
);

document.addEventListener(
  'ModalOpened',
  attachBehaviors,
);

document.addEventListener(
  'PaginationLoaded',
  attachBehaviors,
);
